import { ErrorHandler, Injectable } from "@angular/core";
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from "@ngx-translate/core";
import { MessageService } from "primeng/api";
import { LogService } from "./core/log.service";

@Injectable()
export class AppErrorHandler extends ErrorHandler {
  constructor(
    private translate: TranslateService,
    private messageService: MessageService,
    private log: LogService,
  ) {
    super();
  }

  override handleError(error: Error | HttpErrorResponse) {
    this.log.log(`AppErrorHandler`);
    if(error && `${error}`.indexOf('ChunkLoadError') !== -1){
      this.log.log(`Load ChunkLoadError`)
      return;
    }
    if(error && (error as any).status === 0){
      this.log.log(`Request is cancelled.`);
      return;
    }
    if(error && (error as any).handled) {
      return super.handleError(error);
    }
    if(error && typeof error === 'object'){
      if((error as any).ignore) {
        return super.handleError(error);
      }
      // prevent duplicate error
      (error as any).handled = true;
    }

    if(error && ((error as any).status === 401 || (error as any).status === 409) ){
      // handled in error.interceptor
    }
    else{
      if(error && typeof error === 'object'){
        (error as any).handled = true;
      }
      this.translate.get('common.error.general').subscribe(value => {
        this.messageService.add({severity:'error', summary: `Error`, detail: value, key: 'toast'});
      });
    }
    
    super.handleError(error);
  }

}
